import {useId, useMemo, useState} from "react";

export type FaqItem = {
	id?: string;
	question: string;
	answer: string;
};

type Props = {
	items: FaqItem[];
	title?: string;
	subtitle?: string;
	defaultOpenIndex?: number;
	allowMultiple?: boolean;
	className?: string;
};

export default function FaqAccordion({
																			 items,
																			 title = "Частые вопросы",
																			 subtitle,
																			 defaultOpenIndex = 0,
																			 allowMultiple = false,
																			 className = "",
																		 }: Props) {
	const uid = useId();

	const normalized = useMemo(
			() =>
					items.map((it, idx) => ({
						...it,
						id: it.id ?? `${uid}-${idx}`,
					})),
			[items, uid]
	);

	const [openIds, setOpenIds] = useState<string[]>(
			normalized[defaultOpenIndex]?.id ? [normalized[defaultOpenIndex].id] : []
	);

	const isOpen = (id: string) => openIds.includes(id);

	const toggle = (id: string) => {
		setOpenIds((prev) => {
			const opened = prev.includes(id);

			if (allowMultiple) {
				return opened ? prev.filter((x) => x !== id) : [...prev, id];
			}

			return opened ? [] : [id];
		});
	};

	return (
			<section className={`faq ${className}`}>
				<div className="faq__head">
					<h2>{title}</h2>
				</div>

				<div className="faq__list">
					{normalized.map((it) => {
						const opened = isOpen(it.id!);
						const btnId = `faq-btn-${it.id}`;
						const panelId = `faq-panel-${it.id}`;

						return (
								<div key={it.id} className={`faq__item ${opened ? "is-open" : ""}`}>
									<button
											id={btnId}
											type="button"
											className="faq__button"
											aria-expanded={opened}
											aria-controls={panelId}
											onClick={() => toggle(it.id!)}
									>
										<span className="faq__q">{it.question}</span>

										<span className="faq__icon" aria-hidden="true">
									<span className="faq__iconLine faq__iconLine--h"/>
									<span className="faq__iconLine faq__iconLine--v"/>
								</span>
									</button>

									<div
											id={panelId}
											role="region"
											aria-labelledby={btnId}
											className="faq__panel"
									>
										<div className="faq__panelInner" dangerouslySetInnerHTML={{__html: it.answer}}/>
									</div>
								</div>
						);
					})}
				</div>
			</section>
	);
}